import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaSignOutAlt } from "react-icons/fa";

export default function EditProfile() {
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    lubricentro: "",
    email: "",
  });
  const [loading, setLoading] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) return;

      const { data, error } = await supabase
        .from("profiles")
        .select("first_name, last_name, lubricentro")
        .eq("id", user.id)
        .single();

      if (!error && data) {
        setProfile({
          ...data,
          email: user.email,
        });
      }
      setLoading(false);
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const {
      data: { user },
    } = await supabase.auth.getUser();

    const { error } = await supabase
      .from("profiles")
      .update({
        first_name: profile.first_name,
        last_name: profile.last_name,
        updated_at: new Date(),
      })
      .eq("id", user.id);

    setLoading(false);

    if (!error) {
      alert("Perfil actualizado correctamente ✅");
      navigate("/");
    } else {
      alert("Error actualizando perfil ❌");
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setPasswordMessage("❌ Las contraseñas no coinciden");
      return;
    }

    const { error } = await supabase.auth.updateUser({ password: newPassword });

    if (error) {
      setPasswordMessage(`❌ Error: ${error.message}`);
    } else {
      setPasswordMessage("✅ Contraseña cambiada con éxito");
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  if (loading) return <p>Cargando...</p>;

  return (
    <div className="dashboard-container">
      {/* HEADER */}
      <div className="dashboard-header">
        <div className="header-content">
          <div className="logo-section">
            <button
              onClick={() => navigate(-1)}
              className="logo-icon"
              title="Volver"
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <FaArrowLeft />
            </button>
            <h1>Perfil</h1>
          </div>
          <div className="header-actions">
            <button onClick={handleLogout} className="logout-button">
              <FaSignOutAlt />
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>

      {/* FORMULARIO PERFIL */}
      <div className="tab-content flex justify-center items-center">
        <form
          onSubmit={handleSubmit}
          className="bg-white text-black shadow-lg rounded-2xl p-6 w-full max-w-md"
        >
          <h2 className="text-xl font-bold mb-4">Editar Perfil</h2>

          <label className="block mb-2">
            Nombre
            <input
              type="text"
              name="first_name"
              value={profile.first_name}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              required
            />
          </label>

          <label className="block mb-2">
            Apellido
            <input
              type="text"
              name="last_name"
              value={profile.last_name}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              required
            />
          </label>

          <label className="block mb-2">
            Email
            <input
              type="email"
              name="email"
              value={profile.email}
              className="w-full border p-2 rounded bg-gray-100 cursor-not-allowed"
              readOnly
            />
          </label>

          <label className="block mb-2">
            Lubricentro
            <input
              type="text"
              name="lubricentro"
              value={profile.lubricentro}
              className="w-full border p-2 rounded bg-gray-100 cursor-not-allowed"
              readOnly
            />
          </label>

          <button
            type="submit"
            className="w-full mt-4 bg-orange-500 text-white p-2 rounded hover:bg-orange-600"
          >
            Guardar cambios
          </button>
        </form>
      </div>

      {/* FORMULARIO CONTRASEÑA */}
      <div className="tab-content flex justify-center items-center mt-6">
        <form
          onSubmit={handleChangePassword}
          className="bg-white text-black shadow-lg rounded-2xl p-6 w-full max-w-md"
        >
          <h2 className="text-xl font-bold mb-4">Cambiar Contraseña</h2>

          <label className="block mb-2">
            Nueva contraseña
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full border p-2 rounded"
              required
            />
          </label>

          <label className="block mb-2">
            Confirmar contraseña
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full border p-2 rounded"
              required
            />
          </label>

          <button
            type="submit"
            className="w-full mt-4 bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
          >
            Cambiar contraseña
          </button>

          {passwordMessage && <p className="mt-2">{passwordMessage}</p>}
        </form>
      </div>
    </div>
  );
}
